import { Component, OnInit } from '@angular/core';
import { ModalController, ActionSheetController, LoadingController } from '@ionic/angular';
import { AngularFireDatabase } from '@angular/fire/database';
import { AngularFireStorage } from '@angular/fire/storage';
import { AngularFireAuth } from '@angular/fire/auth';
import { Camera, CameraOptions } from '@ionic-native/camera/ngx';
import { Router } from '@angular/router';
import { OrderPipe } from 'ngx-order-pipe';

@Component({
  selector: 'app-images',
  templateUrl: './images.page.html',
  styleUrls: ['./images.page.scss'],
})
export class ImagesPage implements OnInit {
  public userId: any;
  public images: any;
  image: any;
  filePath: string;
  task: any;
  date = new Date().getTime();

  constructor(
    public loadingController: LoadingController,
    private router: Router,
    public modalController: ModalController,
    public actionSheetController: ActionSheetController,
    public afDB: AngularFireDatabase,
    public afSG: AngularFireStorage,
    public afAuth: AngularFireAuth,
    private camera: Camera,
    private orderPipe: OrderPipe
  ) {
    this.afAuth.authState.subscribe(auth => {
      if (!auth) {
        console.log('non connecté');
        this.router.navigateByUrl('/login');
      } else {
        console.log('Connecté: ' + auth.uid);
        this.userId = auth.uid;
      }
    });
  }

  ngOnInit() {
    this.getImages();
  }

  async closeModal() {
    this.modalController.dismiss();
  }

  async delete(image: any) {
    const actionSheet = await this.actionSheetController.create({
      buttons: [{
        text: 'Supprimer',
        role: 'destructive',
        icon: 'trash',
        handler: () => {
          console.log('Delete clicked: ' + image.key);
          this.afDB.object('Visualisations/' + this.userId + '/' + image.key).remove();
          this.afSG.storage.refFromURL(image.url).delete();
          // .ref(image.url).delete();
          // var storageRef = firebase.storage().ref();
          // storageRef.child(item.photoId).delete();
          // this.refreshData();
        }
      }, {
        text: 'Annuler',
        icon: 'close',
        role: 'cancel',
        handler: () => {
          console.log('Cancel clicked');
        }
      }]
    });
    await actionSheet.present();
  }

  getImages() {
    const imageRef = this.afDB.list('Visualisations/' + this.userId);
    imageRef.snapshotChanges(['child_added', 'child_removed'])
    .subscribe(actions => {
      const that = this;
      const data = [];
      let count = 0;
      actions.forEach((action: any) => {
        that.afSG.ref(action.payload.val().imgUrl).getDownloadURL().subscribe(postUrl => {
          if (action.payload.val().order === '') {
            data.push({
              url: postUrl,
              key: action.payload.key,
              order: count
            });
            console.log(postUrl);
            this.images = this.orderPipe.transform(data, 'order');
          } else {
            data.push({
              url: postUrl,
              key: action.payload.key,
              order: action.payload.val().order
            });
            console.log('data: ' + data[count]);
            this.images = this.orderPipe.transform(data, 'order');
          }
          count++;
        });
        // this.images = data;
      });
    });
  }

  async addImage() {
    const base64 = await this.captureImage();
    this.createUploadTask(base64);
  }

  async captureImage() {
    const options: CameraOptions = {
      quality: 100,
      destinationType: this.camera.DestinationType.DATA_URL,
      encodingType: this.camera.EncodingType.JPEG,
      mediaType: this.camera.MediaType.PICTURE,
      targetWidth: 1000,
      targetHeight: 1000,
      sourceType: this.camera.PictureSourceType.PHOTOLIBRARY
    };
    return await this.camera.getPicture(options);
  }

  createUploadTask(file: string): void {
      this.filePath = 'image_' + this.date + '.jpg';
      this.image = 'data:image/jpg;base64,' + file;
  }

  async publish() {
    const loading = await this.loadingController.create();
    await loading.present();
    this.task = this.afSG.ref(this.filePath).putString(this.image, 'data_url');
    this.task.then(async () => {
      this.afDB.object('Visualisations/' + this.userId + '/' + this.date).set({
        imgUrl: this.filePath
      });
      this.refreshData();
      await loading.dismiss();
    });
  }

  refreshData() {
    this.image = '';
    this.getImages();
    this.date = new Date().getTime();
  }

  doReorder(ev: any) {
    const draggedItem = this.images.splice(ev.detail.from, 1)[0];
    this.images.splice(ev.detail.to, 0, draggedItem);
    let count = 0;
    this.images.forEach((element) => {
      this.afDB.object('Visualisations/' + this.userId + '/' + element.key + '/order').set(count);
      console.log(element.key + ' -> ' + count);
      count++;
    });
    ev.detail.complete();
    this.getImages();
  }

  hideImage() {
    this.image = '';
  }

}
